import readingTypes from './readingTypes-es-ES.json';
import cards from './cards-es-ES.json';
const esESTranslations = {
    "title": "Bienvenido {{name}}, a react usando react-i18next completamente type-safe",
    "splashScreen": {
        "title": "Mensajes que guían, equilibrio que florece",
        "mobileAccess": "Por favor accede a través de un dispositivo móvil"
    },
    "login": {
        "title": "Iniciar Sesión",
        "emailLabel": "Correo electrónico",
        "passwordLabel": "Contraseña",
        "signInButton": "Iniciar Sesión",
        "orSignInWith": "O inicia sesión con",
        "signInWithGoogle": "Iniciar Sesión con Google",
        "signInWithApple": "Iniciar Sesión con Apple",
        "signInWithFacebook": "Iniciar Sesión con Facebook",
        "noAccount": "¿No tienes una cuenta?",
        "register": "Registrarse",
        "forgotPassword": "¿Olvidaste tu contraseña?",
        "resetHere": "Restablécelo aquí",
        "errorFillFields": "Por favor completa todos los campos",
        "errorInvalidCredentials": "Credenciales inválidas, por favor intenta de nuevo.",
        "errorGoogleLogin": "Error al iniciar sesión con Google",
        "errorGoogleLoginGeneric": "Error en el inicio de sesión con Google"
    },
    "register": {
        "title": "Crear Cuenta",
        "firstNameLabel": "Nombre",
        "lastNameLabel": "Apellido",
        "emailLabel": "Correo electrónico",
        "passwordLabel": "Contraseña",
        "confirmPasswordLabel": "Confirmar Contraseña",
        "registerButton": "Registrarse",
        "orRegisterWith": "O regístrate con",
        "registerWithGoogle": "Registrarse con Google",
        "registerWithApple": "Registrarse con Apple",
        "registerWithFacebook": "Registrarse con Facebook",
        "hasAccount": "¿Ya tienes una cuenta?",
        "signIn": "Iniciar Sesión",
        "errorFillFields": "Por favor completa todos los campos requeridos",
        "errorPasswordsMatch": "Las contraseñas no coinciden",
        "errorRegistrationFailed": "Error en el registro",
        "errorGoogleRegistration": "Error al registrarse con Google",
        "errorGoogleRegistrationGeneric": "Error en el registro con Google"
    },
    "forgotPassword": {
        "title": "Restablecer Contraseña",
        "description": "Ingresa tu dirección de correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.",
        "emailLabel": "Correo electrónico",
        "resetButton": "Restablecer Contraseña",
        "rememberPassword": "¿Recuerdas tu contraseña?",
        "signIn": "Iniciar Sesión",
        "errorEnterEmail": "Por favor ingresa tu dirección de correo electrónico",
        "errorResetFailed": "Error al procesar, usuario no encontrado.",
        "successResetSent": "Las instrucciones para restablecer la contraseña han sido enviadas a tu correo electrónico"
    },
    "modeSelector": {
        "title": "¿Qué Misterios Te Buscan?",
        "digitalCards": "Cartas Digitales",
        "physicalCards": "Cartas Físicas",
        "comingSoon": "Próximamente",
        "questionLabel": "¿Qué te gustaría saber?",
        "questionPlaceholder": "Comparte tu pregunta con el universo... (ej., 'Busco orientación sobre...')",
        "beginReading": "Comenzar Lectura"
    },
    "cameraCapture": {
        "yourPhotos": "Tus Fotos",
        "noPhotosYet": "Aún no hay fotos. ¡Comienza a capturar!",
        "galleryPreview": "Vista Previa de Galería"
    },
    "readingCards": {
        "readingFortune": "Interpretando tus cartas...",
        "readingCards": "Leyendo tus Cartas",
        "sessionExpired": "Sesión expirada. Por favor inicia sesión de nuevo.",
        "errorReading": "Error durante la lectura de tarot. Por favor intenta de nuevo.",
        "cardsShuffledMessage": "Tus cartas están barajadas, si quieres puedes barajar nuevamente."
    },
    "feedback": {
        "title": "Gracias por enviarnos tus ideas, problemas o apreciaciones.",
        "description": "No podemos responder individualmente, pero lo pasaremos a los equipos que están trabajando para ayudar a hacer Plenamente mejor para todos.",
        "helpCenter": "Si tienes una pregunta específica o necesitas ayuda para resolver un problema, puedes visitar nuestro Centro de Ayuda o contactarnos para conectarte con nuestro equipo de soporte.",
        "helpCenterLink": "Centro de Ayuda",
        "contactLink": "contáctanos",
        "feedbackAbout": "¿Sobre qué es tu comentario?",
        "topicFeature": "¿Qué tema o función?",
        "addDetails": "Agregar detalles",
        "submit": "Enviar",
        "thankYou": "¡Gracias por tu comentario!",
        "errorSubmitting": "Error al enviar comentario. Por favor intenta de nuevo.",
        "categories": {
            "experiences": "Experiencias",
            "technical": "Técnico",
            "other": "Otro"
        },
        "topics": {
            "experienceQuality": "Calidad de experiencia y comunicación",
            "appFunctionality": "Funcionalidad de la aplicación",
            "readingExperience": "Experiencia de lectura",
            "journalFeatures": "Funciones del diario",
            "accountSettings": "Cuenta y configuración",
            "performanceStability": "Rendimiento y estabilidad",
            "other": "Otro"
        }
    },
    "notifications": {
        "searchMessages": "Buscar Mensajes",
        "tabs": {
            "all": "Todos",
            "support": "Soporte",
            "reading": "Lectura",
            "message": "Mensaje"
        },
        "notifications": [
            {
                "title": "Tu Lectura Diaria Está Lista",
                "description": "Tu lectura de Tres Cartas para hoy ya está disponible"
            },
            {
                "title": "Nuevo mensaje de tu Asesor de Tarot",
                "description": "He revisado tu lectura reciente y tengo algunas ideas adicionales para compartir"
            },
            {
                "title": "Sesión de Lectura Confirmada",
                "description": "Tu sesión de lectura en vivo con Sarah está programada para mañana a las 2 PM"
            },
            {
                "title": "Pronóstico Semanal Completado",
                "description": "Tu pronóstico semanal de tarot ha sido generado. ¡Échale un vistazo!"
            },
            {
                "title": "Discusión de la Comunidad",
                "description": "Nuevas respuestas en el hilo 'Entendiendo La Torre'"
            },
            {
                "title": "Suscripción Renovada",
                "description": "Tu suscripción premium de tarot ha sido renovada exitosamente"
            },
            {
                "title": "Lectura de Luna Nueva Disponible",
                "description": "La lectura especial de fase lunar ya está lista para tu revisión"
            },
            {
                "title": "Invitación a Lectura Grupal",
                "description": "Has sido invitado a unirte a una sesión de lectura grupal este fin de semana"
            },
            {
                "title": "Hito de Cuenta",
                "description": "¡Has completado 50 lecturas! Desbloquea tu insignia de logro"
            },
            {
                "title": "Lectura Cruz Celta Completada",
                "description": "Los resultados de tu lectura profunda de Cruz Celta están listos"
            }
        ]
    },
    "superMarkets": {
        "title": "Supermercados"
    },
    "settings": {
        "personalInformation": "Información personal",
        "personalProfile": "Perfil personal",
        "paymentsPayouts": "Pagos y retiros",
        "notifications": "Notificaciones",
        "privacySharing": "Privacidad y compartir",
        "feedback": "Comentarios",
        "logout": "Cerrar sesión",
        "language": "Idioma",
        "saveChanges": "Guardar Cambios"
    },
    "onboarding": {
        "steps": {
            "userGoal": "Objetivo del Usuario",
            "experience": "Experiencia",
            "deck": "Mazo",
            "birthData": "Datos de Nacimiento",
            "frequency": "Frecuencia",
            "aiTone": "Tono de IA",
            "credits": "Créditos",
            "privacy": "Privacidad",
            "complete": "Completar"
        },
        "common": {
            "continue": "Continuar",
            "skipForNow": "Omitir por ahora",
            "beginReading": "Comenzar Lectura"
        },
        "account": {
            "title": "Crea tu cuenta",
            "advantages": {
                "saveReadings": "Guarda tus lecturas",
                "personalNotes": "Notas personales",
                "syncedDevices": "Sincronizado entre dispositivos",
                "aiInsights": "Insights con IA",
                "dailyCompanion": "Compañero de orientación diaria"
            }
        },
        "userGoal": {
            "title": "¿En qué te gustaría recibir orientación?",
            "options": {
                "loveRelationships": "Amor y Relaciones",
                "careerFinances": "Carrera y Finanzas",
                "personalGrowth": "Crecimiento Personal",
                "healthWellbeing": "Salud y Bienestar",
                "curiosityExploration": "Curiosidad y Exploración"
            }
        },
        "tarotExperience": {
            "title": "¿Qué tan familiarizado estás con el tarot?",
            "options": {
                "newToTarot": "Nuevo en el Tarot",
                "newToTarotDescription": "Apenas estoy comenzando",
                "someExperience": "Algo de Experiencia",
                "someExperienceDescription": "Conozco lo básico",
                "experiencedReader": "Lector Experimentado",
                "experiencedReaderDescription": "Bien versado en tarot"
            }
        },
        "deckPreference": {
            "title": "Elige tu estilo de mazo preferido",
            "options": {
                "riderWaite": "Rider-Waite",
                "celestialMinimalist": "Celestial Minimalista",
                "thoth": "Thoth"
            }
        },
        "birthData": {
            "title": "Ingresa tus datos de nacimiento",
            "description": "Esto ayuda a alinear tus lecturas con tu plan cósmico",
            "helpAlign": "Esto ayuda a alinear tus lecturas con tu plan cósmico",
            "birthDate": "Fecha de Nacimiento",
            "birthTime": "Hora de Nacimiento (si la conoces)",
            "birthPlace": "Lugar de Nacimiento",
            "birthPlacePlaceholder": "Ciudad, País",
            "cityCountryPlaceholder": "Ciudad, País"
        },
        "readingFrequency": {
            "title": "¿Con qué frecuencia quieres lecturas?",
            "options": {
                "daily": "Diariamente",
                "dailyDescription": "Comienza cada día con orientación",
                "weekly": "Semanalmente",
                "weeklyDescription": "Insights más profundos una vez a la semana",
                "occasionally": "Ocasionalmente",
                "occasionallyDescription": "Solo cuando necesites orientación"
            }
        },
        "aiTone": {
            "title": "¿Cómo debe la IA interpretar tus lecturas?",
            "description": "Puedes cambiar esto en cualquier momento en configuración",
            "changeTime": "Puedes cambiar esto en cualquier momento en configuración",
            "options": {
                "directPractical": "Directo y Práctico",
                "directPracticalDescription": "Orientación clara y práctica",
                "gentleIntuitive": "Gentil e Intuitivo",
                "gentleIntuitiveDescription": "Insights acogedores y de apoyo",
                "deepSymbolic": "Profundo y Simbólico",
                "deepSymbolicDescription": "Sabiduría profunda y metafórica"
            }
        },
        "creditIntro": {
            "title": "Entendiendo el sistema de créditos",
            "subtitle": "Comienzas con 3 créditos gratuitos",
            "description": "Cada lectura usa 1 crédito. Puedes obtener más créditos cuando lo necesites.",
            "acknowledgment": "Entiendo cómo funcionan los créditos",
            "startWithFreeCredits": "Comienzas con 3 créditos gratuitos",
            "eachReadingUsesOneCredit": "Cada lectura usa 1 crédito. Puedes obtener más créditos cuando lo necesites.",
            "understandCredits": "Entiendo cómo funcionan los créditos"
        },
        "privacy": {
            "title": "Tu camino es solo tuyo",
            "description": "Todo lo que ves aquí es privado y sagrado. Tus datos son seguros y solo visibles para ti.",
            "acknowledgment": "Entiendo que mis lecturas son privadas",
            "everythingPrivate": "Todo lo que ves aquí es privado y sagrado. Tus datos son seguros y solo visibles para ti.",
            "understandPrivateReadings": "Entiendo que mis lecturas son privadas"
        },
        "completion": {
            "title": "Tu viaje te espera",
            "description": "¡Todo listo! Tu experiencia de tarot ha sido personalizada según tus preferencias.",
            "allSet": "¡Todo listo! Tu experiencia de tarot ha sido personalizada según tus preferencias.",
            "beginReading": "Comenzar Lectura"
        }
    },
    "cardsMeaningWidget": {
        "title": "Descubre los Significados de las Cartas",
        "description": "Explora el rico simbolismo e interpretaciones de las 78 cartas del tarot"
    },
    "customMessage": {
        "goodMorning": "Buenos Días",
        "goodAfternoon": "Buenas Tardes",
        "goodEvening": "Buenas Noches",
        "greeting": "{{greeting}}, {{name}}. Hoy es {{date}}. Tu día a simple vista:"
    },
    "journal": {
        "noEntriesYet": "Aún no hay entradas en el diario",
        "startJourney": "Comienza tu viaje de diario agregando tu primera entrada",
        "addEntry": "Agregar Entrada al Diario",
        "title": "Título",
        "howAreYouFeeling": "¿Cómo te sientes?",
        "writeYourThoughts": "Escribe tus pensamientos...",
        "saveEntry": "Guardar Entrada",
        "update": "Actualizar",
        "save": "Guardar",
        "myDay": "Mi Día",
        "journal": "Diario",
        "moods": {
            "happy": "Feliz",
            "calm": "Tranquilo",
            "anxious": "Ansioso",
            "stressed": "Estresado",
            "excited": "Emocionado",
            "neutral": "Neutral",
            "sad": "Triste",
            "angry": "Enojado"
        }
    },
    "fastReadingCategory": {
        "questionLabel": "¿Qué te gustaría saber?",
        "beginReading": "Comenzar Lectura",
        "noFavorites": "Aún no hay lecturas favoritas. ¡Comience a leer para ver sus favoritos aquí!"
    },
    "cards": {
        "majorArcana": {
            "theFool": "El Loco",
            "theMagician": "El Mago",
            "theHighPriestess": "La Sacerdotisa",
            "theEmpress": "La Emperatriz",
            "theEmperor": "El Emperador",
            "theHierophant": "El Hierofante",
            "theLovers": "Los Enamorados",
            "theChariot": "El Carro",
            "strength": "La Fuerza",
            "theHermit": "El Ermitaño",
            "wheelOfFortune": "La Rueda de la Fortuna",
            "justice": "La Justicia",
            "theHangedMan": "El Colgado",
            "death": "La Muerte",
            "temperance": "La Templanza",
            "theDevil": "El Diablo",
            "theTower": "La Torre",
            "theStar": "La Estrella",
            "theMoon": "La Luna",
            "theSun": "El Sol",
            "judgement": "El Juicio",
            "theWorld": "El Mundo"
        },
        "cups": {
            "aceOfCups": "As de Copas",
            "twoOfCups": "Dos de Copas",
            "threeOfCups": "Tres de Copas",
            "fourOfCups": "Cuatro de Copas",
            "fiveOfCups": "Cinco de Copas",
            "sixOfCups": "Seis de Copas",
            "sevenOfCups": "Siete de Copas",
            "eightOfCups": "Ocho de Copas",
            "nineOfCups": "Nueve de Copas",
            "tenOfCups": "Diez de Copas",
            "pageOfCups": "Paje de Copas",
            "knightOfCups": "Caballero de Copas",
            "queenOfCups": "Reina de Copas",
            "kingOfCups": "Rey de Copas"
        },
        "pentacles": {
            "aceOfPentacles": "As de Pentáculos",
            "twoOfPentacles": "Dos de Pentáculos",
            "threeOfPentacles": "Tres de Pentáculos",
            "fourOfPentacles": "Cuatro de Pentáculos",
            "fiveOfPentacles": "Cinco de Pentáculos",
            "sixOfPentacles": "Seis de Pentáculos",
            "sevenOfPentacles": "Siete de Pentáculos",
            "eightOfPentacles": "Ocho de Pentáculos",
            "nineOfPentacles": "Nueve de Pentáculos",
            "tenOfPentacles": "Diez de Pentáculos",
            "pageOfPentacles": "Paje de Pentáculos",
            "knightOfPentacles": "Caballero de Pentáculos",
            "queenOfPentacles": "Reina de Pentáculos",
            "kingOfPentacles": "Rey de Pentáculos"
        },
        "swords": {
            "aceOfSwords": "As de Espadas",
            "twoOfSwords": "Dos de Espadas",
            "threeOfSwords": "Tres de Espadas",
            "fourOfSwords": "Cuatro de Espadas",
            "fiveOfSwords": "Cinco de Espadas",
            "sixOfSwords": "Seis de Espadas",
            "sevenOfSwords": "Siete de Espadas",
            "eightOfSwords": "Ocho de Espadas",
            "nineOfSwords": "Nueve de Espadas",
            "tenOfSwords": "Diez de Espadas",
            "pageOfSwords": "Paje de Espadas",
            "knightOfSwords": "Caballero de Espadas",
            "queenOfSwords": "Reina de Espadas",
            "kingOfSwords": "Rey de Espadas"
        },
        "wands": {
            "aceOfWands": "As de Bastos",
            "twoOfWands": "Dos de Bastos",
            "threeOfWands": "Tres de Bastos",
            "fourOfWands": "Cuatro de Bastos",
            "fiveOfWands": "Cinco de Bastos",
            "sixOfWands": "Seis de Bastos",
            "sevenOfWands": "Siete de Bastos",
            "eightOfWands": "Ocho de Bastos",
            "nineOfWands": "Nueve de Bastos",
            "tenOfWands": "Diez de Bastos",
            "pageOfWands": "Paje de Bastos",
            "knightOfWands": "Caballero de Bastos",
            "queenOfWands": "Reina de Bastos",
            "kingOfWands": "Rey de Bastos"
        },
        "lenormand": {
            "rider": "Jinete",
            "clover": "Trébol",
            "ship": "Barco",
            "house": "Casa",
            "tree": "Árbol",
            "clouds": "Nubes",
            "snake": "Serpiente",
            "coffin": "Ataúd",
            "bouquet": "Ramo",
            "scythe": "Guadaña",
            "whip": "Látigo",
            "birds": "Pájaros",
            "child": "Niño",
            "fox": "Zorro",
            "bear": "Oso",
            "stars": "Estrellas",
            "stork": "Cigüeña",
            "dog": "Perro",
            "tower": "Torre",
            "garden": "Jardín",
            "mountain": "Montaña",
            "crossroads": "Encrucijada",
            "mice": "Ratones",
            "heart": "Corazón",
            "ring": "Anillo",
            "book": "Libro",
            "letter": "Carta",
            "man": "Hombre",
            "woman": "Mujer",
            "lily": "Lirio",
            "sun": "Sol",
            "moon": "Luna",
            "key": "Llave",
            "fish": "Pez",
            "anchor": "Ancla",
            "cross": "Cruz"
        }
    },
    "cardDialog": {
        "primaryMeaning": "Significado Principal",
        "interpretation": "Interpretación",
        "reversed": "Invertida"
    },
    "cardCategories": {
        "majorArcana": "Arcanos Mayores",
        "cups": "Copas",
        "pentacles": "Pentáculos",
        "swords": "Espadas",
        "wands": "Bastos"
    },
    "pages": {
        "journal": "Diario",
        "shareFeedback": "Compartir Comentarios",
        "readingCards": "Leyendo Cartas",
        "reading": "Lectura",
        "displayReading": "Mostrar Lectura",
        "modeSelector": "Selector de Modo",
        "selectReading": "Seleccionar Lectura",
        "settings": "Configuración",
        "payments": "Pagos",
        "personalInformation": "Información Personal",
        "personalProfile": "Perfil Personal",
        "readingList": "Lista de Lecturas",
        "notifications": "Notificaciones",
        "cardMeanings": "Significados de Cartas",
        "chat": "Chat"
    },
    "readingPage": {
        "directAnswer": "Tu Respuesta Directa",
        "yourQuestion": "Tu Pregunta",
        "theSpread": "El Tirada",
        "cardInteractions": "Interacciones de Cartas",
        "conclusion": "Conclusión",
        "practicalAdvice": "Consejo Práctico",
        "readMore": "Leer Más",
        "touchCardsInfo": "Toca las cartas para más información",
        "noReadingsFound": "No se encontraron lecturas",
        "tryNewReading": "¡Intenta hacer una nueva lectura primero!",
        "startAudioReading": "🎧 Iniciar Lectura de Audio"
    },
    "home": {
        "dailyReading": "Tu Lectura Diaria",
        "completeReading": "Lectura Completa",
        "favoriteReadingTypes": "Tus Tipos de Lectura Favoritos",
        "dailyReadingPrompt": "Descubre el mensaje que el universo tiene para ti hoy",
        "chooseCard": "Elige tu Carta",
        "getPremium": {
            "bestValue": "Mejor Valor",
            "title": "Obtener Premium",
            "description": "Lecturas Personalizadas Casi Ilimitadas"
        },
        "statistics": {
            "topSuit": "Palo Principal",
            "topNumberOrRank": "Número o Rango Principal",
            "last7Days": "Últimos 7 Días"
        }
    },
    "credits": {
        "availableCredits": "Créditos Disponibles",
        "buyCredits": "Comprar Créditos",
        "creditsDescription": "Los créditos se usan para generar lecturas y acceder a funciones premium.",
        "betaTestTitle": "Créditos de Prueba Beta",
        "betaTestDescription": "Tienes 200 créditos gratuitos para explorar todas las funciones durante nuestra fase de prueba beta. ¡Estos créditos te permitirán experimentar todo el potencial de nuestras lecturas de tarot!",
        "recentActivity": "Actividad Reciente",
        "noRecentActivity": "Sin actividad reciente",
        "creditsUpdatedSuccess": "¡Créditos actualizados exitosamente!"
    },
    "personalInfo": {
        "description": "Actualiza tu información personal y preferencias",
        "firstName": "Nombre",
        "lastName": "Apellido",
        "username": "Nombre de Usuario",
        "email": "Correo Electrónico",
        "password": "Contraseña",
        "confirmPassword": "Confirmar Contraseña",
        "gender": "Género",
        "selectGender": "Seleccionar Género",
        "male": "Masculino",
        "female": "Femenino",
        "other": "Otro",
        "preferNotToSay": "Prefiero no decir",
        "dateOfBirth": "Fecha de Nacimiento",
        "preferredLanguage": "Idioma Preferido",
        "selectPreferredLanguage": "Seleccionar Idioma Preferido",
        "address": "Dirección",
        "street": "Calle",
        "number": "Número",
        "complement": "Complemento",
        "zipCode": "Código Postal",
        "city": "Ciudad",
        "state": "Estado",
        "country": "País",
        "selectCountry": "Seleccionar País",
        "unitedStates": "Estados Unidos",
        "canada": "Canadá",
        "france": "Francia",
        "germany": "Alemania",
        "validation": {
            "passwordsDoNotMatch": "Las contraseñas no coinciden"
        },
        "messages": {
            "profileSavedSuccess": "Perfil guardado exitosamente",
            "failedToUpdateProfile": "Error al actualizar el perfil",
            "noAuthToken": "No se encontró token de autenticación"
        }
    },
    "personalProfile": {
        "title": "Perfil Personal",
        "experienceLevel": "Nivel de Experiencia",
        "selectExperienceLevel": "Seleccionar Nivel de Experiencia",
        "preferredReadingStyle": "Estilo de Lectura Preferido",
        "selectPreferredReadingStyle": "Seleccionar Estilo de Lectura Preferido",
        "useReversedCards": "Usar Cartas Invertidas",
        "primaryLifeFocus": "Enfoque Principal de Vida",
        "selectPrimaryLifeFocus": "Seleccionar Enfoque Principal de Vida",
        "intentions": "Intenciones",
        "selectIntentions": "Seleccionar Intenciones",
        "language": "Idioma",
        "selectLanguage": "Seleccionar Idioma"
    },
    "billing": {
        "title": "Lee tus cartas, en cualquier momento y obtén respuestas personalizadas.",
        "credits": "Créditos",
        "betterValue": "MEJOR VALOR",
        "bestValue": "MEJOR VALOR",
        "creditsNeverExpire": "Los créditos nunca expiran y solo se canjean por preguntas que pueden responderse con tarot.",
        "buyQuestions": "COMPRAR {{count}} PREGUNTAS",
        "processingPurchase": "Procesando su compra, esto puede llevar un momento...",
        "purchaseSuccessPolling": "¡Compra exitosa! Sus créditos se actualizarán en unos instantes.",
        "purchaseDelayed": "¡Compra exitosa! Los créditos se actualizarán pronto.",
        "purchaseFailed": "Error en la compra: {{error}}"
    },
    "payment": {
        "emailLabel": "Correo electrónico",
        "emailPlaceholder": "Ingresa tu correo electrónico",
        "cardDetailsLabel": "Datos de la tarjeta",
        "processing": "Procesando...",
        "buyNow": "Comprar Ahora",
        "errorInvalidPriceId": "Error: ID de precio inválido",
        "errorCardElementNotFound": "Elemento de tarjeta no encontrado.",
        "errorAuthTokenNotFound": "Token de autenticación no encontrado",
        "successPayment": "¡Pago exitoso! Recibirás un correo electrónico de confirmación en breve.",
        "errorInvalidPriceIdDetail": "ID de precio inválido: {{priceId}}",
        "errorUnknown": "Ocurrió un error desconocido",
        "errorPrefix": "Error: "
    },
    "welcomeSpread": {
        "initialMessage": "Respira conmigo un instante.\nEn pocas palabras: ¿sobre qué situación buscas claridad hoy?",
        "thankYouMessage": "Gracias por compartir. Estoy aquí para ayudarte a encontrar claridad.",
        "placeholder": "Escribe tu mensaje...",
        "recording": "Grabando..."
    },
    "navigation": {
        "today": "Inicio",
        "readings": "Lecturas",
        "journal": "Diario",
        "feedback": "Comentarios",
        "settings": "Configuración"
    },
    "profileOptions": {
        "experienceLevels": {
            "newToTarot": "Nuevo en el tarot",
            "someExperience": "Alguna experiencia",
            "experiencedReader": "Lector experimentado"
        },
        "readingFrequencies": {
            "daily": "Diario",
            "weekly": "Semanal",
            "occasionally": "Ocasionalmente"
        },
        "deckPreferences": {
            "riderWaite": "Rider-Waite",
            "celestialMinimalist": "Minimalista Celestial",
            "thoth": "Thoth"
        },
        "userGoals": {
            "loveRelationships": "Amor y relaciones",
            "careerFinances": "Carrera y finanzas",
            "personalGrowth": "Crecimiento personal",
            "healthWellbeing": "Salud y bienestar",
            "curiosityExploration": "Curiosidad y exploración"
        },
        "aiTonePreferences": {
            "directPractical": "Directo y práctico",
            "gentleIntuitive": "Gentil e intuitivo",
            "deepSymbolic": "Profundo y simbólico"
        },
        "languages": {
            "english": "Inglés",
            "portuguese": "Portugués",
            "spanish": "Español",
            "french": "Francés",
            "german": "Alemán"
        }
    },
    "reading": {
        "wasThisHelpful": "¿Te fue útil esta lectura?",
        "helpful": "Útil",
        "notHelpful": "No útil",
        "helpfulSuccess": "¡Gracias por tu comentario!",
        "notHelpfulSuccess": "¡Gracias por tu comentario!",
        "evaluationError": "Error al guardar tu evaluación"
    },
    "cardSelection": {
        "title": "Selecciona Tus Cartas",
        "cardsSelected": "{{count}} / {{max}} cartas seleccionadas",
        "shuffleCards": "Barajar Cartas",
        "shuffling": "Barajando...",
        "selectionComplete": "Selección Completa..."
    },
    // Import readingTypes from external file
    readingTypes,
    cardsTranslations: cards.cardsTranslations
};

export default esESTranslations; 